export default __webpack_public_path__ + "static/media/hht2_ep09_book_wp_02.d55b0b72.jpg";